import { Meta } from '@solidjs/meta';
import { useNavigate } from '@solidjs/router';
import { JSX } from 'solid-js';

export type RouteType =  (() => JSX.Element);

export type RoutesType = {[name:string]:  RouteType};

export interface IRoutesProvider 
{
	routes(): RoutesType;  
}



/* Good for most local redirects, provided permissions are OK */
export function Navigate(props)
{
	useNavigate()(props.url);
	return <></>
}


export function GeneralRedirect(props)
{
/* XXX REDIRECT POSSIBILITIES:
1. Solid Routers redirect() - currently only works in action() and event handlers. May change in time.
		Subscribed to this bug https://github.com/solidjs/solid-router/issues/429
   This method would remove an unnecessary page load.
2. Express response object ==> Tried this. Seems Solid Router has already sent headers to the client.
   This method would remove an unnecessary page load.
3. Send <meta> direct in HTML 
*/

//XXX NOTE the redirect page probably has some unnecessary extra content...
	return (
		<Meta http-equiv='refresh' content={`0; url=${props.url}`}/>
	);
}

